<template>
  <div class="OpenAccountProcessBox">
    <AOAP></AOAP>
    <!-- <TemplateDownload></TemplateDownload> -->
  </div>
</template>

<script>
import AOAP from './components/AOAP.vue'
import TemplateDownload from './components/TemplateDownload.vue'
export default {
  components: {
    AOAP,
    TemplateDownload
  },
  props: {},
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.OpenAccountProcessBox {
  height: 100%;
  width: 910px;
  margin: 0 auto;
  // border: 1px solid transparent;
}

</style>